// base
import { createSlice } from '@reduxjs/toolkit';
import { EXCEL_SLICE_NAME } from '../actions/excel.action';

// thunks
import { downLoadExcels, downLoadExcelTemplate, createBatchExcel } from '../thunks/excel.thunk';

export interface ExcelState {
  excelData?: Blob;
}

// initialState
const initialState: ExcelState = {
  excelData: undefined
};

const excelSlice = createSlice({
  name: EXCEL_SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createBatchExcel.fulfilled, (state, action) => {})
      .addCase(downLoadExcelTemplate.fulfilled, (state, action) => {
        state.excelData = action.payload.data;
      })
      .addCase(downLoadExcels.fulfilled, (state, action) => {
        state.excelData = action.payload.data;
      });
  }
});

export const excel = excelSlice.name;
export const excelReducer = excelSlice.reducer;
export const excelActions = excelSlice.actions;
export default excelSlice.reducer;
